import React from "react";
import AnnexGroupTableOfContentsRecord from "models/view-models/table-of-contents/annex-group-table-of-contents-record";
import VirtualTableOfContentsAnnexGroup from "molecules/virtual-table-of-contents-items/virtual-table-of-contents-annex-group";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

interface VirtualTableOfContentsAnnexGroupsProps {
    annexGroups: AnnexGroupTableOfContentsRecord[];
    annexNfpaLabel: string;
    isPublic?: boolean;
}

// #endregion Interfaces

const CSS_CLASS_NAME = "c-virtual-table-of-contents";

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const VirtualTableOfContentsAnnexGroups: React.FunctionComponent<
    VirtualTableOfContentsAnnexGroupsProps
> = (props: VirtualTableOfContentsAnnexGroupsProps) => {
    const { annexGroups, annexNfpaLabel, isPublic = false } = props;

    return (
        <nav className={`${CSS_CLASS_NAME} -annexGroups`}>
            <ul className={`${CSS_CLASS_NAME}__list`}>
                {annexGroups.map((annexGroup) => (
                    <VirtualTableOfContentsAnnexGroup
                        annexGroup={annexGroup}
                        annexNfpaLabel={annexNfpaLabel}
                        isPublic={isPublic}
                        key={annexGroup.groupBy}
                    />
                ))}
            </ul>
        </nav>
    );
};

// #endregion Component

// -----------------------------------------------------------------------------------------
// #region Export
// -----------------------------------------------------------------------------------------

export default VirtualTableOfContentsAnnexGroups;

// #endregion Export
